import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidateQrService } from '../validate-qr.service';
import { AnalyticsService } from '../services/analytics.service';
import { QrCatalogService } from '../services/qr-catalog.service';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.css']
})
export class QrcodeComponent implements OnInit {

  public qrid: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private validateQr: ValidateQrService,
    private analytics: AnalyticsService,
    private qrCatalog: QrCatalogService
  ) {}

  async ngOnInit() {
    console.log('QrcodeComponent iniciado');
    this.qrid = this.route.snapshot.paramMap.get('qrid');
    console.log('QR ID recibido:', this.qrid);

    if (!this.qrid) {
      console.error('No se recibio parametro qrid');
      this.router.navigate(['noqr']);
      return;
    }

    // === Analitica GA4: entrada por QR fisico ===
    // Hacemos esto ANTES de validar para no perder el evento si el backend
    // invalida el totem (nos interesa saber que alguien escaneo).
    try {
      console.log('Cargando catalogo QR...');
      await this.qrCatalog.ensureLoaded();
      const match = this.qrCatalog.findByCodigo(this.qrid);

      if (match) {
        console.log('QR encontrado:', match);
        // Custom event (no aparece en "Vistas por titulo de pagina")
        this.analytics.trackQrScanEntry({
          qr_code: this.qrid,
          totem_id: match.tot_id,
          totem_name: match.nombre,
          floor: match.piso
        });
        // page_view explicito con el nombre del QR en el titulo para que
        // SI aparezca en el reporte "Vistas por titulo de pagina" de GA4
        // (ej: "QR: P2QR3 (Piso 2)").
        const friendly = 'QR: ' + match.nombre +
          (match.piso ? ' (' + match.piso + ')' : '');
        this.analytics.sendPageView('/qr/' + match.nombre, friendly, {
          totem_id: match.tot_id,
          totem_name: match.nombre,
          floor: match.piso
        });
      } else {
        // QR no catalogado: igual emitimos con datos minimos.
        console.warn('QR no encontrado en catalogo:', this.qrid);
        this.analytics.trackQrScanEntry({
          qr_code: this.qrid,
          totem_name: 'desconocido'
        });
        this.analytics.sendPageView('/qr/desconocido', 'QR: desconocido');
      }
      sessionStorage.setItem('qr_entry_sent', '1');
    } catch (err) {
      console.error('Error en GA4 trackQrScanEntry:', err);
    }

    // === Validacion original (no tocamos el flujo de negocio) ===
    console.log('Validando QR...');
    try {
      const res = this.validateQr.validateQrCode((this.qrid || '').toString());
      console.log('Resultado validacion:', res);
      if (res) {
        console.log('Navegando a home');
        this.router.navigate(['']);
      } else {
        console.log('QR invalido, navegando a noqr');
        this.router.navigate(['noqr']);
      }
    } catch (error) {
      console.error('Error durante validacion:', error);
      this.router.navigate(['noqr']);
    }
  }
}
